import React, { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import { CartaoProvider } from '../hooks/useCartao'
import { FiltrosProvider } from '../hooks/useFiltro'
import { TransferenciaProvider } from '../hooks/useTransferencia'
import TmovPayInstructions from '../pages/Pagamento/TmovPayInstructions'
import PagamentoRoutes from '../utils/PagamentoRoutes'
import TransferenciaFactory from '../factories/Transferencia'
import { ExtratoFactory } from '../factories/Extrato'
import { PorcentagemTransferenciaFactory } from '../factories/PorcentagemTransferencia'
import HomePagamentoFactory from '../factories/HomePagamento'
import { TrazerDinheiroFactory } from '../factories/TrazerDinheiro'
import { ComprovantesExtratoFactory } from '../factories/ComprovantesExtrato'
import PagamentoBoletoFactory from '../factories/PagamentoBoleto'
import { PagamentoBoletoProvider } from '../hooks/usePagamentoBoleto'
import { ComprovanteProvider } from '../hooks/useComprovante'
import OnboardingFactory from '../factories/Onboarding'
import { OnboardingProvider } from '../hooks/useOnboarding'

const PagamentosRoutes: FunctionComponent = () => {
  return (
    <CartaoProvider>
      <FiltrosProvider>
        <Switch>
          <TransferenciaProvider>
            <PagamentoBoletoProvider>
              <ComprovanteProvider>
                <OnboardingProvider>
                  <Route
                    path={PagamentoRoutes.PAGAMENTO}
                    isPrivate
                    exact
                    component={HomePagamentoFactory}
                  />
                  <Route
                    path={PagamentoRoutes.TRANSFERENCIA}
                    isPrivate
                    exact
                    component={TransferenciaFactory}
                  />
                  <Route
                    path={PagamentoRoutes.EXTRATO}
                    isPrivate
                    exact
                    component={ExtratoFactory}
                  />
                  <Route
                    path={PagamentoRoutes.PORCENTAGEM_TRANSFERENCIA}
                    isPrivate
                    exact
                    component={PorcentagemTransferenciaFactory}
                  />

                  <Route
                    path={PagamentoRoutes.PAGAMENTO_BOLETO}
                    isPrivate
                    exact
                    component={PagamentoBoletoFactory}
                  />
                  <Route
                    path={PagamentoRoutes.TRAZER_DINHEIRO}
                    isPrivate
                    exact
                    component={TrazerDinheiroFactory}
                  />
                  <Route
                    path={PagamentoRoutes.INSTRUCOES}
                    isPrivate
                    exact
                    component={TmovPayInstructions}
                  />
                  <Route
                    path={PagamentoRoutes.COMPROVANTE}
                    isPrivate
                    exact
                    component={ComprovantesExtratoFactory}
                  />
                  <Route
                    path={PagamentoRoutes.ONBOARDING}
                    isPrivate
                    exact
                    component={OnboardingFactory}
                  />
                </OnboardingProvider>
              </ComprovanteProvider>
            </PagamentoBoletoProvider>
          </TransferenciaProvider>
        </Switch>
      </FiltrosProvider>
    </CartaoProvider>
  )
}

export default PagamentosRoutes
